import React from 'react';
import VerificationPhone from '../../components/SecurityVerification/VerificationPhone';

const PhoneAuthenticationPage = () => {
	return <VerificationPhone />;
};

export default PhoneAuthenticationPage;
